<div class="card" *ngFor="let item of items" 
[class.not-enough-inventory]="item?.inventoryOnHand - item?.addedQuantity < 0 && item?.activityType !== 3"
(click)="openConfirmationDialog.emit(item.id)" [style.min-width.px]="minWidth" [ngClass]="cardCustomClasses">
<div class="rx-number">
   <div>
      Rx{{item?.rxNumber}} <span *ngIf="item?.isPartialFill && item?.partialNumber > 0"> - {{item.partialNumber}}</span>
   </div>
   <app-badge *ngIf="item?.activityType === 3"
      [color]="BadgeColorsEnum.Blue"> Amended </app-badge>
   <app-badge *ngIf="item?.activityType === 0 && item?.description && !item?.isC2KeepPartialDispense"
      [maxWidth]="'200px'"
   > {{item?.description?.replace("Picked Up", "P/U")}} </app-badge>
   <app-badge *ngIf="item?.isC2KeepPartialDispense && item?.description"
      [color]="BadgeColorsEnum.Yellow"> {{item?.description}} 
   </app-badge>
</div>
<div class="display-name">{{item?.friendlyName}}</div>
<div class="patient-name">{{item?.patientName}}</div>
</div>